import { Box, Fade, Typography } from "@mui/material";
import { tabs } from "./data";
import { useState } from "react";
import TabBar from "./tabs/booking-details/components/TabBar";
import BookingDetails from "./tabs/booking-details/BookingDetails";
import ProposalTab from "./tabs/proposals/Proposals";
import { useBookingData } from "../view-booking/hooks/UseBookingData";

import BookingAudit from "./tabs/audit/BookingAudit";
import MemoryTableTab from "./tabs/memory-table/MemoryTableTab";
import ClientReviewTab from "./tabs/client-review/ClientReview";

const isFuneralBooking = (bookingType?: string | null) => {
  const type = bookingType?.toUpperCase();
  return !type || type === "FUNERAL" || type === "FUNERAL_HOME";
};

export default function ViewBookingPage2() {
  const [activeTab, setActiveTab] = useState(0);
  const { bookingData } = useBookingData();

  const tabLabels = tabs.map((label, index) =>
    index === 2 && !isFuneralBooking(bookingData?.booking_type)
      ? "Comments"
      : label,
  );

  return (
    <Box sx={{ px: { xs: 1, sm: 2 } }}>
      <TabBar tabs={tabLabels} activeIndex={activeTab} onChange={setActiveTab} />

      <Fade in={activeTab === 0} unmountOnExit={false}>
        <Box sx={{ display: activeTab === 0 ? "block" : "none" }}>
          <BookingDetails />
        </Box>
      </Fade>
      <Fade in={activeTab === 1} unmountOnExit={false}>
        <Box sx={{ display: activeTab === 1 ? "block" : "none" }}>
          <ProposalTab bookingData={bookingData} />
        </Box>
      </Fade>
      <Fade in={activeTab === 2} unmountOnExit={false}>
        <Box sx={{ display: activeTab === 2 ? "block" : "none" }}>
          <MemoryTableTab bookingData={bookingData} />
        </Box>
      </Fade>
      <Fade in={activeTab === 3} unmountOnExit={false}>
        <Box sx={{ display: activeTab === 3 ? "block" : "none" }}>
          {bookingData ? (
            <ClientReviewTab bookingId={bookingData.id.toString()} />
          ) : (
            <Typography>Loading review...</Typography>
          )}
        </Box>
      </Fade>
      <Fade in={activeTab === 4} unmountOnExit={false}>
        <Box sx={{ display: activeTab === 4 ? "block" : "none" }}>
          {bookingData ? (
            <BookingAudit bookingId={bookingData.id.toString()} />
          ) : (
            <Typography>Loading audit history...</Typography>
          )}
        </Box>
      </Fade>
    </Box>
  );
}
